import { combineReducers } from "redux"
import documentsReducer from "./documentsReducer"

const rootReducer = combineReducers({
  documents_list: documentsReducer,
});

export default rootReducer
